import React from 'react';
import { Chip } from '@mui/material';
import { BookOnline } from '@mui/icons-material';

export const BranchStatusBadge = ({ status }: { status: string }) => {
  const isOpened = status === "50";
  const isClosed = status === "53" || status === "51";
  return (
    <Chip
      label={isOpened ? "Ouvert" : isClosed ? "Fermé" : "Inconnu"}
      color={isOpened ? "success" : isClosed ? "error" : "warning"}
      size="small" variant="outlined" sx={{ borderRadius: 1, fontWeight: 'bold' }}
    />
  );
};

export const CaisseStatusBadge = ({ status, onClick, disabled }: { status: string, onClick: () => void, disabled: boolean }) => (
  <Chip
    onClick={onClick} disabled={disabled} clickable={!disabled}
    color={status !== '53' ? 'error' : 'success'}
    label={status !== '53' ? <BookOnline fontSize="small" /> : 'F'}
    variant="outlined" sx={{ borderRadius: 1, minWidth: '40px' }}
  />
);

export const IndicatorBadge = ({ count, onClick, disabled }: { count: number, onClick: () => void, disabled: boolean }) => (
  <Chip
    onClick={onClick} disabled={disabled} clickable={!disabled}
    color={count === 0 ? 'success' : count > 10 ? 'error' : 'warning'}
    label={count} variant="filled" sx={{ borderRadius: 1, minWidth: '40px', fontWeight: 'bold' }}
  />
);